import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ButtonComponent } from 'ui-elements/button';
import { ModalComponent } from 'ui-elements/modal';
import {
  NotificationMessage,
  NotificationModalServiceService,
} from '../../services/notification-modal-service.service';
import {
  animate,
  query,
  style,
  transition,
  trigger,
} from '@angular/animations';

@Component({
  selector: 'ss-www-notification-modal',
  imports: [CommonModule, ModalComponent, ButtonComponent],
  templateUrl: './notification-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('modalAnimation', [
      transition(':enter', [
        query('.modal', [
          style({ opacity: 0, transform: 'scale3d(0.3, 0.3, 0.3)' }),
          animate(
            '0.3s ease-in-out',
            style({ opacity: 1, transform: 'scale3d(1, 1, 1)' })
          ),
        ]),
      ]),
    ]),
  ],
})
export class NotificationModalComponent {
  private notificationModalService = inject(NotificationModalServiceService);

  notificationMessage$: Observable<NotificationMessage | undefined>;

  constructor() {
    const notificationModalService = this.notificationModalService;

    this.notificationMessage$ = notificationModalService.notificationMessage$;
  }

  closeModal() {
    this.notificationModalService.clear();
  }
}
//EOF
